/**
 * @generated SignedSource<<023861fe47ba2e0777941d22674737d6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_sku";
};
export type PdpRespSidebarBlurbShipping_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "12820ceca972f2e2e92fd508d5ce4121";

export default node;
